import CacheHelper from '@/helper/CacheHelper';
// import Util from '@/helper/Utility.js'

const CACHE_FORM_ADDRESS = 'form-address'

export function FormAddressModel() {
    this.firstname = '';
    this.lastname = '';
    this.contactNumber = '';
    this.address = '';
    this.addressName = '';
    this.subDistrictCode = null;
    this.subDistrictName = null;
    this.districtCode = null;
    this.districtName = null;
    this.provinceCode = null;
    this.provinceName = null;
    this.zipcode = '';
    this.isDefault = false;
    this.rowKey = '';

    this.setValueFromAddressModel = function (addressModel) {
        // this.provinceName = addressModel.provinceName;
        // this.districtName = addressModel.districtName;
        // this.subDistrictName = addressModel.subDistrictName;
        this.subdistrictCode = addressModel.subDistrictCode;
        this.subdistrictName = addressModel.subDistrictName;
        this.districtCode = addressModel.districtCode;
        this.districtName = addressModel.districtName;
        this.provinceCode = addressModel.provinceCode;
        this.provinceName = addressModel.provinceName;
        this.zipcode = addressModel.zipcode;
        this.isDefault = addressModel.isDefault;
        this.rowKey = addressModel.rowKey;
    };

    this.hasCache = function () {
        let cache = new CacheHelper('session')
        let data = cache.getCache(CACHE_FORM_ADDRESS)

        return data != null
    }

    this.saveCache = function () {
        let cache = new CacheHelper('session')
        // let json = Util.normalObject(this)
        cache.setCache(CACHE_FORM_ADDRESS, this)
    }

    this.removeCache = function () {
        let cache = new CacheHelper('session')
        cache.removeCache(CACHE_FORM_ADDRESS)
    }

    this.loadCache = function () {
        let cache = new CacheHelper('session')
        let data = cache.getCache(CACHE_FORM_ADDRESS)

        if (data == null) {
            return
        }

        this.address = data.address;
        this.addressName = data.addressName;
        this.building = data.building;
        this.companyName = data.companyName;
        this.contactNumber = data.contactNumber;
        this.countryCode = data.countryCode;
        this.countryId = data.countryId;
        this.countryName = data.countryName;
        this.districtCode = data.districtCode;
        this.districtName = data.districtName;
        this.email = data.email;
        this.firstname = data.firstname;
        this.floor = data.floor;
        this.homeContactNumber = data.homeContactNumber;
        this.idCard = data.idCard;
        this.isDefault = data.isDefault;
        this.isDefaultTax = data.isDefaultTax;
        this.landmark = data.landmark;
        this.lastname = data.lastname;
        this.lat = data.lat;
        this.lng = data.lng;
        this.moo = data.moo;
        this.name = data.name;
        this.number = data.number;
        this.partitionKey = data.partitionKey;
        this.provinceCode = data.provinceCode;
        this.provinceName = data.provinceName;
        this.remark = data.remark;
        this.road = data.road;
        this.room = data.room;
        this.rowKey = data.rowKey;
        this.soi = data.soi;
        this.subDistrictCode = data.subDistrictCode;
        this.subDistrictName = data.subDistrictName;
        this.type = data.type;
        this.village = data.village;
        this.zipcode = data.zipcode;
        this.title = data.title;
        this.personType = data.personType;
    }

    this.getFullAddressText = function() {
        var str = this.addressName + ' '
                + this.subDistrictName + ' '
                + this.districtName + ' '
                + this.provinceName;
        return str;
    };

    this.setValueFormApi = function(data) {
        if (data == null) {
            data = {};
        }
        this.address = data.Address;
        this.addressName = data.AddressName;
        this.building = data.Building;
        this.companyName = data.CompanyName;
        this.contactNumber = data.ContactNumber;
        this.countryCode = data.CountryCode;
        this.countryId = data.CountryId;
        this.countryName = data.CountryName;
        this.districtCode = data.DistrictCode;
        this.districtName = data.DistrictName;
        this.email = data.Email;
        this.firstname = data.FirstName;
        this.floor = data.Floor;
        this.homeContactNumber = data.HomeContactNumber;
        this.idCard = data.IdCard;
        this.isDefault = data.IsDefault;
        this.isDefaultTax = data.IsDefaultTax;
        this.landmark = data.Landmark;
        this.lastname = data.LastName;
        this.lat = data.Latitude;
        this.lng = data.Longitude;
        this.moo = data.Moo;
        this.name = data.Name;
        this.number = data.Number;
        this.partitionKey = data.PartitionKey;
        this.provinceCode = data.ProvinceCode;
        this.provinceName = data.ProvinceName;
        this.remark = data.Remark;
        this.road = data.Road;
        this.room = data.Room;
        this.rowKey = data.RowKey;
        this.soi = data.Soi;
        this.subDistrictCode = data.SubDistrictCode;
        this.subDistrictName = data.SubDistrictName;
        this.taxAddress = data.TaxAddressName;
        this.taxDistrictCode = data.TaxDistrictCode;
        this.taxDistrictName = data.TaxDistrictName;
        this.taxId = data.TaxId;
        this.taxName = data.TaxName;
        this.taxNumber = data.TaxNumber;
        this.taxProvinceCode = data.TaxProvinceCode;
        this.taxProvinceName = data.TaxProvinceName;
        this.taxSoi = data.TaxSoi;
        this.taxSubDistrictCode = data.TaxSubDistrictCode;
        this.taxSubDistrictName = data.TaxSubDistrictName;
        this.taxZipcode = data.TaxZipcode;
        this.type = data.Type;
        this.village = data.Village;
        this.zipcode = data.Zipcode;
        this.title = data.Title;
        this.personType = data.PersonType;
    };
}
